/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDisabledOff = createReactComponent("disabled-off", "IconDisabledOff", [
  ["path", { d: "M11 7a2 2 0 1 0 -2 -2", key: "svg-0" }],
  ["path", { d: "M11 11v4h4l4 5", key: "svg-1" }],
  ["path", { d: "M15 11h1", key: "svg-2" }],
  ["path", { d: "M7 11.5a5 5 0 1 0 6 7.5", key: "svg-3" }],
  ["path", { d: "M3 3l18 18", key: "svg-4" }]
]);

export { IconDisabledOff as default };
//# sourceMappingURL=IconDisabledOff.js.map
